/**
 * @file: 动画控制
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import Utils from '../../utils/util';
import Config from '../../config/index';
import SelectStore from './store/index';

const maxFlowCubesCount: number = Config.get({
    moduleName: 'base',
    key: 'maxFlowCubesCount'
});

function startAnimation(cubeIds: CubeId[]): void {
    cubeIds.forEach((cubeId: CubeId): void => {
        let cube: CubeNode|null = CubeTree.findByCubeId(cubeId);

        if (CubeTree.isShelf(cubeId)) {
            let nextShelf: CubeId|null = CubeTree.findNextShelf(cubeId);
            let shelf: CubeNode|null = CubeTree.findByCubeId(nextShelf);

            shelf && shelf.jView && shelf.jView.removeClass('stop-border-animation');
        }

        cube && cube.jView && cube.jView.removeClass('stop-border-animation');
    });
}

function stopAnimation(cubeIds: CubeId[]): void {
    cubeIds.forEach((cubeId: CubeId): void => {
        let cube: CubeNode|null = CubeTree.findByCubeId(cubeId);

        if (CubeTree.isShelf(cubeId)) {
            let nextShelf: CubeId|null = CubeTree.findNextShelf(cubeId);
            let shelf: CubeNode|null = CubeTree.findByCubeId(nextShelf);

            shelf && shelf.jView && shelf.jView.addClass('stop-border-animation');
        }

        cube && cube.jView && cube.jView.addClass('stop-border-animation');
    });
}

function flow(): void {
    let allSelectCubeIds: Array<CubeId> = SelectStore.getAll();

    if (allSelectCubeIds.length > maxFlowCubesCount) {
        stopAnimation(allSelectCubeIds);
    }
    else {
        startAnimation(allSelectCubeIds);
    }
}

function stopAllSelectedAnimation(): void {
    let allSelectCubeIds: Array<CubeId> = SelectStore.getAll();

    stopAnimation(allSelectCubeIds);
}

// 打开所有选中cube动画，需要判断性能阈值
function startAllSelectedAnimation(): void {
    let allSelectCubeIds: Array<CubeId> = SelectStore.getAll();

    if (allSelectCubeIds.length <= maxFlowCubesCount) {
        startAnimation(allSelectCubeIds);
    }
}

const flowAsync = Utils.debounce(flow, 10);
const startAllSelectedAnimationAsync = Utils.debounce(startAllSelectedAnimation, 800);

export {
    startAnimation,
    stopAnimation,
    stopAllSelectedAnimation,
    startAllSelectedAnimation,
    startAllSelectedAnimationAsync,
    flowAsync
};
